module.exports = __webpack_public_path__ + "28e6ae67f28139dda3dfbc319f6af4c3.pdf";